import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ViewEncapsulation, OnInit, SimpleChange, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CommonAutoCompleteModel } from './autocompletecomponent';
import { AutoCompleteService } from './auto-complete.service';
import { MatAutocompleteSelectedEvent } from '../../../../node_modules/@angular/material/autocomplete';
import { MatAutocomplete } from '../../../../node_modules/@angular/material/autocomplete';
import { MatAutocompleteTrigger } from '../../../../node_modules/@angular/material/autocomplete';
import { debounceTime, distinctUntilChanged, switchMap } from '../../../../node_modules/rxjs/operators';

@Component({
  selector: 'app-autocomplete-controller',
  templateUrl: './auto-complete.component.html',
  encapsulation: ViewEncapsulation.None // to display focused value on arrow key
})

export class AutoCompleteComponent implements OnInit, OnChanges {
  // Property declaration
  @Input() MethodName: string;
  @Output() selectedvalue: EventEmitter<CommonAutoCompleteModel> = new EventEmitter<CommonAutoCompleteModel>();
  @Input() bindValue: string; // Property is used when required to assign on screen Load
  @Input() type: string = '';
  @Input() autodisabled: boolean = false;
  @Input() autofocus: boolean = false;
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) matAutocompleteTrigger: MatAutocompleteTrigger;
  @ViewChild('name') focus: ElementRef;

  myControl = new FormControl();

  filteredOptions = [];

  displayPlaceHolder: boolean = true;
  lblNoRecord: string = '';
  searcheditem: CommonAutoCompleteModel = new CommonAutoCompleteModel();
  searchedword: string;


  // Call service method on value change to call service
  constructor(private autoService: AutoCompleteService) {

    this.myControl.valueChanges
      .pipe(
        debounceTime(50),
        distinctUntilChanged()
        , switchMap((data) => data && data.length >= 2 ? this.autoService.search_word(data, this.MethodName) : this.resetcontroller())
      )
      .subscribe(
        response => {
          if (response && response.length > 0 && response[0].UserId > 0) {
            this.filteredOptions = response;
            this.displayPlaceHolder = false;
            this.lblNoRecord = '';
          }
          else {
            this.filteredOptions = [];
            if (this.type == 'loginId' && response.length > 0) {
              this.lblNoRecord = '';
              this.searcheditem.UserId = response[0].UserId;
              this.searcheditem.LoginId = this.myControl.value === response[0].LoginId ? response[0].LoginId : this.myControl.value;
              this.selectedvalue.emit(this.searcheditem);
            }
            else if (this.type == 'loginId' && response.length === 0) {
              this.lblNoRecord = '';
            }
            else {
              this.lblNoRecord = 'No record found';
            }
          }
        });
  }

  // Call on page initialization
  ngOnInit(): void {
    this.DisableSection();
  }

  // Disable control based on condition
  DisableSection() {
    if (this.autodisabled && this.autodisabled === true) {
      this.myControl.disable();
    }
    else {
      this.myControl.enable();
    }
  }

  // Reset searched Controller if 2 characters only
  resetcontroller() {
    this.filteredOptions = [];
    this.selectedvalue.emit(new CommonAutoCompleteModel());
    return [];
  }
  // Call to bind value of searched value to control on change
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes && changes.autodisabled && changes.autodisabled.firstChange === false) {
      this.DisableSection();
    }

    if (changes && changes.bindValue && changes.bindValue.firstChange === false) {
      this.myControl.patchValue(this.bindValue);
      this.lblNoRecord = '';
    }
    if (this.autofocus && this.autofocus === true) {
      this.focus.nativeElement.focus();
    }
  }

  // Emit selected value which is passed to output variable
  fetchSelected(item) {
    this.selectedvalue.emit(item);
    this.displayPlaceHolder = false;
  }

  // Display selected value in textbox
  displayFn(item): string {
    return item;
  }

  // Select first value from suggested list on tab
  onKey(event: any) { // without type info
    if (event.key == 'Tab') {
      if (this.matAutocomplete.options.first) {
        this.matAutocomplete.options.first.select();
      }
    }
  }

  // Mat autocomplete selected event
  displayForm(event: MatAutocompleteSelectedEvent) {
    if (event.option.value) {
    }
  }

}
